import React from "react";
import Markdown from "markdown-to-jsx";
import ClickablePhone from "../ClickablePhone";

const elements = [
	"a",
	"abbr",
	"address",
	"area",
	"article",
	"aside",
	"audio",
	"b",
	"base",
	"bdi",
	"bdo",
	"big",
	"blockquote",
	"body",
	"br",
	"button",
	"canvas",
	"caption",
	"cite",
	"code",
	"col",
	"colgroup",
	"data",
	"datalist",
	"dd",
	"del",
	"details",
	"dfn",
	"dialog",
	"div",
	"dl",
	"dt",
	"em",
	"embed",
	"fieldset",
	"figcaption",
	"figure",
	"footer",
	"form",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hgroup",
	"hr",
	"html",
	"i",
	"iframe",
	"img",
	"input",
	"ins",
	"kbd",
	"keygen",
	"label",
	"legend",
	"li",
	"link",
	"main",
	"map",
	"mark",
	"marquee",
	"menu",
	"menuitem",
	"meta",
	"meter",
	"nav",
	"noscript",
	"object",
	"ol",
	"optgroup",
	"option",
	"output",
	"p",
	"param",
	"picture",
	"pre",
	"progress",
	"q",
	"rp",
	"rt",
	"ruby",
	"s",
	"samp",
	"script",
	"section",
	"select",
	"small",
	"source",
	"span",
	"strong",
	"style",
	"sub",
	"summary",
	"sup",
	"table",
	"tbody",
	"td",
	"textarea",
	"tfoot",
	"th",
	"thead",
	"time",
	"title",
	"tr",
	"track",
	"u",
	"ul",
	"var",
	"video",
	"wbr",

	// SVG
	"circle",
	"clipPath",
	"defs",
	"ellipse",
	"foreignObject",
	"g",
	"image",
	"line",
	"linearGradient",
	"marker",
	"mask",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"radialGradient",
	"rect",
	"stop",
	"svg",
	"text",
	"tspan",
];

const allowedElements = ["a", "b", "strong", "em", "u", "code", "del", "phonenumber"];

const CustomLink = ({ children, href, ...props }) => {
	if (href && href.startsWith("phone:")) {
		return <ClickablePhone>{children}</ClickablePhone>;
	}
	return (
		<a href={href} {...props} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	);
};

const MarkdownWrapper = ({ children, disableLinks }) => {
	const boldRegex = /\*(.*?)\*/g;
	const tildaRegex = /~(.*?)~/g;
	// Regex robusto para capturar números de telefone preservando urls
	const phoneRegex = /(?<!\w|\/)(?:\+?\d{1,3}[\s-]?)?(?:\(?\d{2,3}\)?[\s-]?)?\d{4,5}[\s-]?\d{4}(?!\w|\/)/g;

	const pixMarker = '###PIX_MARKER###';

	let formattedChildren = children;

	if (typeof formattedChildren === "string") {
		if (formattedChildren.includes('***')) {
			formattedChildren = formattedChildren.replace(/\*\*\*/g, pixMarker);
		}

		if (boldRegex.test(formattedChildren)) {
			formattedChildren = formattedChildren.replace(boldRegex, "**$1**");
		}

		if (formattedChildren.includes(pixMarker)) {
			formattedChildren = formattedChildren.replace(new RegExp(pixMarker, 'g'), '***');
		}

		if (tildaRegex.test(formattedChildren)) {
			formattedChildren = formattedChildren.replace(tildaRegex, "~~$1~~");
		}

		if (phoneRegex.test(formattedChildren)) {
			formattedChildren = formattedChildren.replace(phoneRegex, "[$&](phone:$&)");
		}
	}
	const options = React.useMemo(() => {
		const markdownOptions = {
			disableParsingRawHTML: true,
			forceInline: true,
			overrides: {
				a: { component: disableLinks ? ({ children }) => <span>{children}</span> : CustomLink },
			},
		};

		elements.forEach(element => {
			if (!allowedElements.includes(element)) {
				markdownOptions.overrides[element] = el => el.children || null;
			}
		});

		return markdownOptions;
	}, [disableLinks]);

	if (!formattedChildren) return null;

	return <Markdown options={options}>{formattedChildren}</Markdown>;
};

export default MarkdownWrapper;
